import { useMemo } from 'react';

import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';

import {
	LanguagesAbbr, SurveyQuestion, SurveyQuestionType
} from '../../../../../../types/working-model';
import Icon, { COLORS, ICONS } from '../../../../../general-ui/icon';

interface SortableQuestion {
	Handlers: { [key: string]: any };
	id: string;
	question: SurveyQuestion;
	handleDeleteQuestion: (question: SurveyQuestion) => () => void;
	language: LanguagesAbbr;
}

export function SurveyQuestionComponent(props: SortableQuestion) {
	const { attributes, listeners, setActivatorNodeRef, setNodeRef, transform } = useSortable({
		id: props.id,
	});

	const { question, Handlers, handleDeleteQuestion, language } = props;

	const style = {
		transform: CSS.Transform.toString(transform),
		transition: 'none',
	};

	const validMultiple = useMemo(() => {
		if (question?.question_type !== SurveyQuestionType.text) {
			return question?.options?.length > 0;
		}

		return true;
	}, [question]);

	const type = useMemo(() => {
		switch (question.question_type) {
			case SurveyQuestionType.text:
				return 'Text area';
			case SurveyQuestionType.radio:
				return 'Select one';
			case SurveyQuestionType.checkbox:
				return 'Select multiple';
		}
	}, [question]);

	if (!question) return null;
	return (
		<div
			className="survey-question"
			ref={setNodeRef}
			style={style}
		>
			<div
				className="drag-handle"
				ref={setActivatorNodeRef}
				{...attributes}
				{...listeners}
			>
				<Icon
					name={ICONS.DRAG_HANDLE}
					size={18}
					color={COLORS.DEFAULT_GRAY}
				/>
			</div>
			<div className="survey-question-info">
				<label>{question?.title?.[language] ?? question?.title?.base}</label>
				<span>
					{type}{' '}
					{!validMultiple && (
						<span className="invalid-multiple">
							(at least one option required)
						</span>
					)}
				</span>
			</div>
			<div className="survey-question-actions">
				<button className="no-style" onClick={() => Handlers.editQuestion(question)}>
					<Icon name={ICONS.EDIT} size={16} color={COLORS.WHITE} />
				</button>
				<button onClick={handleDeleteQuestion(question)} className="no-style">
					<Icon name={ICONS.TRASH} size={16} color={COLORS.WHITE} />
				</button>
			</div>
		</div>
	);
}
